const BASE = '/api';

async function checkStatus(r) {
  if (r.status === 401) throw new Error('401');
  if (!r.ok) throw new Error(await r.text());
  return r;
}

async function readJson(r) {
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const error = new Error(data.error || r.statusText || 'Anfrage fehlgeschlagen');
    error.code = data.code;
    throw error;
  }
  return data;
}

export async function login(username, password) {
  const r = await fetch(`${BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  return r;
}

export async function logout() {
  await fetch(`${BASE}/logout`, { method: 'POST' });
}

export async function fetchPasskeyStatus() {
  return readJson(await fetch(`${BASE}/passkeys/status`));
}

export async function fetchPasskeys() {
  return readJson(await fetch(`${BASE}/passkeys`));
}

export async function createPasskeyRegistrationOptions() {
  return readJson(await fetch(`${BASE}/passkeys/registration/options`, { method: 'POST' }));
}

export async function verifyPasskeyRegistration(response, name) {
  return readJson(await fetch(`${BASE}/passkeys/registration/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ response, name }),
  }));
}

export async function createPasskeyAuthenticationOptions() {
  return readJson(await fetch(`${BASE}/passkeys/authentication/options`, { method: 'POST' }));
}

export async function verifyPasskeyAuthentication(response) {
  return readJson(await fetch(`${BASE}/passkeys/authentication/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(response),
  }));
}

export async function deletePasskey(id) {
  return readJson(await fetch(`${BASE}/passkeys/${id}`, { method: 'DELETE' }));
}

export async function fetchBoxen() {
  const r = await checkStatus(await fetch(`${BASE}/boxen`));
  return r.json();
}

export async function fetchBox(id) {
  const r = await checkStatus(await fetch(`${BASE}/boxen/${id}`));
  return r.json();
}

export async function fetchKategorien() {
  const r = await checkStatus(await fetch(`${BASE}/kategorien`));
  return r.json();
}

export async function fetchNextBoxNumber() {
  const r = await checkStatus(await fetch(`${BASE}/boxen/next-number`));
  return r.json();
}

export async function reserveBoxNumbers(anzahl) {
  const r = await fetch(`${BASE}/boxen/reservieren`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ anzahl }),
  });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function fetchLabelPrintStatus() {
  const r = await checkStatus(await fetch(`${BASE}/etiketten/status`));
  return r.json();
}

export async function prepareLabelRange(von, bis, erneutBestaetigt = false) {
  const r = await fetch(`${BASE}/etiketten/vorbereiten`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ von, bis, erneut_bestaetigt: erneutBestaetigt }),
  });
  const data = await r.json();
  if (!r.ok) {
    const error = new Error(data.error || r.statusText);
    error.code = data.code;
    error.details = data;
    throw error;
  }
  return data;
}

export async function markLabelRangePrinted(von, bis) {
  const r = await fetch(`${BASE}/etiketten/gedruckt`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ von, bis }),
  });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function assignBoxLocation(boxNummer, standort) {
  const r = await fetch(`${BASE}/boxen/zuordnen`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ box_nummer: boxNummer, standort, bei_bedarf_anlegen: true }),
  });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function createBox(formData) {
  const r = await fetch(`${BASE}/boxen`, { method: 'POST', body: formData });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function updateBox(id, formData) {
  const r = await fetch(`${BASE}/boxen/${id}`, { method: 'PUT', body: formData });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function deleteBox(id) {
  const r = await fetch(`${BASE}/boxen/${id}`, { method: 'DELETE' });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function addFotos(boxId, formData) {
  const r = await fetch(`${BASE}/boxen/${boxId}/fotos`, { method: 'POST', body: formData });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function deleteFoto(fotoId) {
  const r = await fetch(`${BASE}/fotos/${fotoId}`, { method: 'DELETE' });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

export async function analyzeFoto(fotoId) {
  const r = await fetch(`${BASE}/fotos/${fotoId}/analyse`, { method: 'POST' });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}

// Legacy – wird noch von BoxForm genutzt falls kein spezifisches Foto bekannt
export async function analyzePhoto(id) {
  const r = await fetch(`${BASE}/boxen/${id}/foto-analyse`, { method: 'POST' });
  if (!r.ok) throw new Error((await r.json()).error || r.statusText);
  return r.json();
}
